import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {
  black,
  cloud,
  cloudLighter,
  denim,
  ravenBlack,
  taupe,
  white,
} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'column',
    flex: 1,
    backgroundColor: white,
    width: '100%',
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center',
  },
  header: {
    paddingBottom: 20,
    width: '100%',
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center',
  },
  backButton: {
    marginTop: 6,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
    alignSelf: 'flex-start',
  },
  backIcon: {
    fontSize: 22,
    color: taupe,
    marginRight: 2,
  },
  backText: {
    color: denim,
    fontWeight: '700',
  },
  headerTitle: {
    fontSize: 20,
    lineHeight: 24,
  },
  list: {
    flex: 1,
    backgroundColor: white,
    width: '100%',
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center',
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  ordersCountText: {
    fontWeight: '700',
  },
  orderDateText: {
    color: ravenBlack,
    fontSize: 15,
    fontWeight: '600',
    lineHeight: 21,
    paddingBottom: 2,
  },
  orderNumberText: {
    color: codGray,
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 21,
    paddingTop: 2,
    paddingBottom: 4,
  },
  orderMetaText: {
    color: ravenBlack,
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 18,
    paddingTop: 2,
  },
  orderMetaRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    paddingTop: 6,
  },
  orderMetaItemContainer: {
    backgroundColor: cloudLighter,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    marginRight: 8,
    marginBottom: 4,
  },
  orderMetaItemText: {
    color: ravenBlack,
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 18,
  },
  orderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  orderContent: {
    flex: 1,
  },
  loadingIndicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  listItem: {},
  keyboardFocusRing: {
    borderWidth: 3,
    borderColor: black,
    borderRadius: 4,
    marginVertical: -16,
    paddingVertical: 16,
  },
  listItemWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloud,
  },
  arrowIcon: {
    color: taupe,
    fontSize: 18,
    paddingLeft: indent * 0.675,
    alignSelf: 'center',
  },
  orderHistoryList: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  listFooterLoadingIndicator: {
    paddingTop: 30,
    paddingBottom: 50,
  },
});
